import { useMutation, useQueryClient } from "@tanstack/react-query";
import { payPointCredentialKeys } from "Api/Queries/PayPoints/usePayPointCredentialQuery";
import { deletePayPointsPublicIDCredential } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  payPointPublicID: string;
  onSuccess?: () => void;
  onError?: () => void;
};

export const useRevokeGatewayCredentialMutation = ({
  payPointPublicID,
  onSuccess,
  onError,
}: Props) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(() =>
      deletePayPointsPublicIDCredential(payPointPublicID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: payPointCredentialKeys.byPayPointPublicId(payPointPublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
